<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12" lg="12">
        <TheCodeDetail @addBread="addBread"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  // name: "Codes",
  components: {
    TheCodeDetail: () =>
      import(
        "@/components/dashboardComponents/TheCodeDetail"
      )
  },
  data: () => ({
    create: false,
    page: {
      title: "Códigos"
    },
    elementVisible: false,
    breadcrumbs: [
      {
        text: "Home",
        disabled: false,
        href: "/dashboard/index/"
      },
      {
        text: "Códigos",
        disabled: false,
        href: "/dashboard/codes/"
      }
    ]
  }),
  computed: {
    ...mapState('codigos', ['codeDetail'])
  },
  methods: {
    addBread () {
      const newBreadCrumb = {
        text: `${this.codeDetail.codigo}`,
        disabled: true
      }
      this.breadcrumbs.push(newBreadCrumb)
    }
  }
};
</script>
